<div class="content">
  <div class="body">
    <div class="body-content">
      <div class="top-bar">
        <div class="title-bar">
          <span class="page-title">Profile<helpTooltip [context]="'profile'"></helpTooltip></span>
          <button mat-icon-button class="circle-button" title="Download all data" (click)="downloadAccount()">
            <img src="assets/download.svg"/>
          </button>
        </div>
        <div *ngIf="!userToView" class="avatar-line skeleton">
          <div class="profile-avatar skeleton-animation"></div>
        </div>
        <div *ngIf="userToView" class="avatar-line">
          <avatar class="profile-avatar" [text]="getName(userToView)" [url]="photoURL"></avatar>
        </div>
        <div *ngIf="!userToView" class="user-info skeleton">
          <div class="profile-avatar skeleton-animation"></div>
          <div class="text" [ngClass]="{showEmail: canShowEmail()}">
            <span class="name skeleton-animation"></span>
            <span class="email skeleton-animation"></span>
            <span class="photo-button skeleton-animation"></span>
          </div>
        </div>
        <div *ngIf="userToView" class="user-info">
          <avatar class="profile-avatar" [text]="getName(userToView)" [url]="photoURL"></avatar>
          <div class="text" [ngClass]="{showEmail: canShowEmail()}">
            <span class="name">{{getName(userToView)}}</span>
            <span class="email">{{userToView.email}}</span>
            <input type="file" accept=".jpeg,.jpg,.png,.gif" title="" class="file-input" [ngClass]="{set: photoURL == null}"
              [disabled]="isSaving()" (change)="fileInputChanged($event)" />
          </div>
        </div>
        <div class="tabs">
          <button mat-button class="body-standard-tab" [ngClass]="{selected: getTab() == 0}" (click)="setTab(0)">Personal Info</button>
          <button mat-button *ngIf="isMainUser()" class="body-standard-tab" [ngClass]="{selected: getTab() == 1}" (click)="setTab(1)">Organizations</button>
        </div>
      </div>
      <div *ngIf="getTab() == 0 && isLoading()" class="fields skeleton">
        <div class="input-area">
          <div class="input-container">
            <span class="label skeleton-animation"></span>
            <div class="input skeleton-animation"></div>
          </div>
          <div class="input-container">
            <span class="label skeleton-animation"></span>
            <div class="input skeleton-animation"></div>
          </div>
          <div class="input-container double">
            <span class="label skeleton-animation"></span>
            <div class="input skeleton-animation"></div>
          </div>
          <div *ngIf="isMainUser()" class="input-container">
            <span class="label skeleton-animation"></span>
            <div class="input skeleton-animation"></div>
          </div>
          <div *ngIf="isMainUser()" class="input-container">
            <span class="label skeleton-animation"></span>
            <div class="input skeleton-animation"></div>
          </div>
        </div>
      </div>
      <div *ngIf="getTab() == 0 && !isLoading()" class="fields">
        <div class="input-area">
          <div class="input-container">
            <span class="label">Change First Name</span>
            <input #name type="text" class="input" maxlength="255" placeholder="First name"
              [disabled]="isSaving()" [(ngModel)]="first" />
          </div>
          <div class="input-container">
            <span class="label">Change Last Name</span>
            <input type="text" class="input" maxlength="255" placeholder="Last name"
              [disabled]="isSaving()"[(ngModel)]="last" />
          </div>
          <div class="input-container double">
            <span class="label">Primary Use Case</span>
            <mat-select class="input select" placeholder="Select primary use case"
              [disabled]="isSaving()" [(ngModel)]="homePref">
              <mat-option *ngFor="let option of homePrefOpts" [value]="option.value">
                {{option.displayValue}}
              </mat-option>
            </mat-select>
          </div>
          <div *ngIf="isMainUser()" class="input-container">
            <span class="label">Change Password</span>
            <div class="input-inner-container">
              <input [type]="passwordShowing ? 'text' : 'password'" class="input" maxlength="255" placeholder="Password"
                [disabled]="isSaving()" [(ngModel)]="password1" />
              <div class="inline-text-button" (click)="togglePasswordShowing()">{{passwordShowing ? 'Hide' : 'Show'}}</div>
            </div>
          </div>
          <div *ngIf="isMainUser()" class="input-container">
            <span class="label">Confirm new password</span>
            <div class="input-inner-container">
              <input [type]="passwordShowing ? 'text' : 'password'" class="input" maxlength="255" placeholder="Confirm password"
                [disabled]="isSaving()" [(ngModel)]="password2" />
              <div class="inline-text-button" (click)="togglePasswordShowing()">{{passwordShowing ? 'Hide' : 'Show'}}</div>
            </div>
          </div>
        </div>
        <div *ngIf="isMainUser()" class="password-checks">
          <div class="condition">
            <img src="assets/check.svg" class="check" [ngClass]="{active: passwordCharacterCountGood()}" />
            <span class="text">Must be at least 8 characters</span>
          </div>
          <div class="condition">
            <img src="assets/check.svg" class="check" [ngClass]="{active: passwordCapitalizationGood()}" />
            <span class="text">Have uppercase and lowercase letters</span>
          </div>
          <div class="condition">
            <img src="assets/check.svg" class="check" [ngClass]="{active: passwordNumberGood()}" />
            <span class="text">Have a number</span>
          </div>
          <div class="condition">
            <img src="assets/check.svg" class="check" [ngClass]="{active: passwordSpecialCharacterGood()}" />
            <span class="text">Have a special character or symbol</span>
          </div>
          <div class="condition">
            <img src="assets/check.svg" class="check" [ngClass]="{active: passwordsMatch()}" />
            <span class="text">Passwords must match</span>
          </div>
        </div>
      </div>
      <div *ngIf="getTab() == 1" class="fields">
        <span class="desc">
          Companies, groups, associations, or other organizations with whom you are associated and that Huddy may use when finding compasses for you
        </span>
        <div *ngIf="!(userToView && !settingsLoading && companies)" class="companies skeleton">
          <div class="company" *ngFor="let i of [1,2,3]">
            <div class="remove-company-button skeleton-animation"></div>
            <span class="company-name skeleton-animation"></span>
          </div>
        </div>
        <div *ngIf="userToView && !settingsLoading && companies && companies.length > 0" class="companies">
          <div class="company" *ngFor="let c of companies">
            <button mat-button class="text-button remove-company-button" [title]="'Remove' + c.name"
              [disabled]="!canSaveCode()" (click)="promptRemoveCompany(c)">
              <img src="assets/inline-remove-red.svg" class="icon">
            </button>
            <span class="company-name">{{c.name}}</span>
          </div>
        </div>
        <button mat-button class="text-button add-company-button" [disabled]="!canSaveCode()" (click)="promptSaveCode()">
          Add an organization or group
        </button>
      </div>
      <div class="buttons">
        <mat-progress-spinner *ngIf="saving" class="spinner" color="primary" mode="indeterminate"
          diameter="21"></mat-progress-spinner>
        <button mat-button class="text-button secondary shy" [disabled]="!canRevert()" (click)="revert()">Discard changes</button>
        <button mat-button class="text-button secondary" *ngIf="canShowDelete()" [disabled]="!canDelete()"
            (click)="promptDelete()">
          Delete account
        </button>
        <button mat-button class="text-button" [disabled]="!canSave()" (click)="save()">Save</button>
      </div>
    </div>
  </div>
</div>
